export const MerchantSuccessFooterStyles = {
  footer:
    'w-full flex flex-col justify-center items-center sm:relative inset-x-0 bottom-0 pt-10 pb-20 bg-skyblue100',
  title: 'text-20px md:text-24px text-blue500 font-semibold',
  cardContainer: 'sm:w-4/6 flex justify-center'
}
